import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrganisationResponseInterface } from '@careapp/angular-sdk';
import { DeveloperCategory, DeveloperFunction } from '@devmod/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import * as actions from './store/actions/index';
import * as selectors from './store/reducers/index';

/**
 * This class represents the main application component.
 */
@DeveloperCategory({
  name: 'Global',
  sort: -1
})
@Component({
  selector: 'sd-app',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  loggedIn: Observable<boolean>;
  user: Observable<any>;
  admin: Observable<boolean>;
  organisations: Observable<OrganisationResponseInterface[]>;
  currentOrganisation: Observable<OrganisationResponseInterface>;
  appLink$: Observable<string>;

  constructor(private store: Store<any>, public router: Router) {
    this.loggedIn = this.store.select(selectors.auth.getLoggedIn);
    this.user = this.store.select(selectors.auth.getLoggedInUser);
    this.currentOrganisation = this.store.select(selectors.getSelected(selectors.ORGANISATIONS));
    this.organisations = this.store.select(selectors.org.getSelectable);
    this.admin = this.store.select(selectors.auth.isAdmin);
    this.appLink$ = this.store
      .select(selectors.auth.getAuthLinkQueryParams)
      .pipe(map(params => `${environment.APP_BASE_URL}/?${params}`));
    console.log('Environment config', environment);
  }

  ngOnInit() {
  }

  @DeveloperFunction()
  logout() {
    this.store.dispatch(new actions.RequestAuthLogoutAction());
  }

  @DeveloperFunction()
  systemBrowser() {
    this.router.navigate(['/', 'system']);
  }

  organisationSelected(id: string) {
    this.store.dispatch(actions.Organisations.SelectByIdAction({ id }));
  }

  profile() {
    this.store.dispatch(actions.NavigateAction({ path: ['profile'] }));
  }
}
